import * as React from 'react'

import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'
import { GridBlock } from '../blocks/GridBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const GridLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const scene = useScene()
  const config = useConfig()

  if (scene.weekly) {
    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '100%',
          zIndex,
          pointerEvents: 'none',
        }}
      >
        <GridBlock
          startTime={scene.startTime}
          height={scene.height}
          width={scene.contentWidth}
          isMonth={scene.days !== 1}
          weekly
          days={scene.days}
          headerHeight={scene.headerHeight}
          bottomPadding={scene.bottomPadding}
          timeToX={scene.timeToX}
          secondsInPeriod={scene.secondsInPeriod}
          onDayClick={config.onDaySelected}
        />
      </div>
    )
  }

  return (
    <LayerWrapper zIndex={zIndex}>
      <GridBlock
        startTime={scene.startTime}
        height={50}
        width={scene.contentWidth}
        isMonth={scene.days !== 1}
        weekly={scene.weekly}
        days={scene.days}
      />
    </LayerWrapper>
  )
}

export default GridLayer
